module.exports = __webpack_public_path__ + "img/add-circle.20324144.svg";